import { render, staticRenderFns } from "./ListFleetV2.vue?vue&type=template&id=39b22d5d&"
import script from "./ListFleetV2.vue?vue&type=script&lang=js&"
export * from "./ListFleetV2.vue?vue&type=script&lang=js&"
import style0 from "./ListFleetV2.vue?vue&type=style&index=0&id=39b22d5d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports